const state = {
    ruleConditions: [{
        ruleId: 1, 
        formId: null, 
        comparatorTypeId: null, 
        value: null, 
        selectedFormCode: null, 
        dataName: null,
        isDisableValueContainer: false
    }],
    ruleConditionsOri: [{
        ruleId: 1, 
        formId: null, 
        comparatorTypeId: null, 
        value: null, 
        selectedFormCode: null, 
        dataName: null
    }],
    nextID: 2
};

const mutations = {
    ADD_CONDITION: (state, data) => {
        state.ruleConditions.push(data);
        state.nextID++;
    },
    SET_CONDITION: (state, data) => {
        console.log("set condition", data);
        if (data && data.length >= 1) {
            state.ruleConditions = [...data];
            let lastID = data[data.length - 1].id;
            state.nextID = lastID;
        }
    },
    REMOVE_CONDITION: (state, index) => {
        state.ruleConditions.splice(index, 1);
    },
  	RESET_CONDITION: (state) => {
        state.ruleConditions = [{
            ruleId: 1, 
            formId: null, 
            comparatorTypeId: null, 
            value: null, 
            selectedFormCode: null, 
            dataName: null
        }];
        state.nextID = 2;
    },
    SPLICE_CONDITION: (state, index) => {
        state.ruleConditions.splice(index, 1);
        if (state.ruleConditions.length == 0) {
            state.ruleConditions = JSON.parse(JSON.stringify(state.ruleConditionsOri));
        }
    }
};

const actions = {
    addCondition({ state, commit }, data) {
        data.ruleId = state.nextID;
        commit("ADD_CONDITION", data);
    },
    removeCondition({ state, commit }, index) {
        if (state.ruleConditions.length > 1) {
            commit("REMOVE_CONDITION", index);
        } else {
            commit("RESET_CONDITION");
        }
    },
    resetCondition({ commit }) {
        commit("RESET_CONDITION");
    },
    setCondition({ commit }, conditions) {
        console.log(conditions);
        conditions.forEach((condition, index) => {
            var code = condition.comparatorType ? condition.comparatorType.code : condition.comparatorCode;
			
            switch (code) {
            case "EMPTY":
            case "NOT_EMPTY":
                conditions[index].isDisableValueContainer = true;
                conditions[index].value = null;
                break;
            default:
                conditions[index].isDisableValueContainer = false;
                break;
            }
        });
        commit("SET_CONDITION", conditions);
    },
    spliceCondition({ commit }, info) {
        console.log("update info", info);
        commit("SPLICE_CONDITION", info);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/rule_conditions.js